/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum FRAME_ATTRS_LIST {
  NAME = "name",
  DESCRIPTION = "description",
  SOURCE = "source",
  OFFSET = "offset",
  LIMIT = "limit",
}
